import { autorun } from "mobx";
import {
  IAPIItemOptionsRequest,
  IAPIItemProgramAndLevelsRequest,
  IAPIItemUsageRequest,
} from "../interfaces";
import { BenefitsModel } from "./BenefitsModel";
import {
  PriceBenefitsInputModel,
  PriceProgramAndLevelsMappingModel,
} from "./PriceInputs.model";
import { getNewErrors, nameof } from "@mindmemobile/mm-shared-global";

export class ServiceAndMembershipOptionsPageModel {
  allowBenefits: boolean;
  selectedBenefits: BenefitsModel[];
  benefits: PriceBenefitsInputModel[];
  programAndLevels: PriceProgramAndLevelsMappingModel[];
  errors: any[];
  constructor(data?: Partial<ServiceAndMembershipOptionsPageModel>) {
    //As per requirement hide usage section
    this.allowBenefits = false; // data?.allowBenefits === true;
    this.selectedBenefits =
      (data?.selectedBenefits &&
        data.selectedBenefits.map((b) => {
          return new BenefitsModel(b);
        })) ||
      [];
    this.benefits =
      (data?.benefits &&
        data.benefits.map((b) => {
          return new PriceBenefitsInputModel(b);
        })) ||
      [];

    this.programAndLevels =
      data?.programAndLevels?.map((p) => {
        return new PriceProgramAndLevelsMappingModel(p);
      }) || [];

    this.errors = data?.errors || [];
    autorun(() => {
      this.validate(true);
    });
  }

  validate(isAutoRun = false): boolean {
    let hasErrors = false;
    const newErrors: any[] = [];
    if (this.allowBenefits) {
      if (this.selectedBenefits.length === 0) {
        newErrors.push({
          field: nameof<ServiceAndMembershipOptionsPageModel>("benefits"),
        });
      }
      this.benefits.forEach((price) => {
        const isValid = price.validate(isAutoRun);
        if (!isValid) {
          hasErrors = true;
        }
      });
    }
    if (isAutoRun) {
      this.errors = getNewErrors(newErrors, this.errors);
    } else {
      this.errors = newErrors;
    }

    const hasErrorInProgramAndLevels = false;
    /* do not validate until program and levels are shown */
    // this.programAndLevels.forEach((programAndLevel) => {
    //     if (!programAndLevel.validate(isAutoRun)) {
    //         hasErrorInProgramAndLevels = true;
    //     }
    // });
    return (
      this.errors.length === 0 && !hasErrors && !hasErrorInProgramAndLevels
    );
  }

  createAPIModel(): IAPIItemUsageRequest {
    return {
      allowBenefits: this.allowBenefits,
      selectedBenefits: this.allowBenefits
        ? this.selectedBenefits.map((sb) => {
            return sb.createAPIModel();
          })
        : [],
      benefits: this.allowBenefits
        ? this.benefits.map((b) => b.createAPIModel())
        : [],
    };
  }

  createProgramAndLevelsAPIModel(): IAPIItemProgramAndLevelsRequest[] {
    return this.programAndLevels
      .map((p) => {
        return p.createAPIModel();
      })
      .filter((x) => x.programId?.length > 0);
  }

  static deserializeAPIModel(
    data: IAPIItemOptionsRequest
  ): ServiceAndMembershipOptionsPageModel {
    const mappedData: Partial<ServiceAndMembershipOptionsPageModel> = {
      allowBenefits: data.usage.allowBenefits,
      selectedBenefits:
        data.usage.selectedBenefits?.map((b) => {
          return new BenefitsModel({
            id: b.id,
            singularName: b.singularName,
            pluralName: b.pluralName,
          });
        }) || [],
      benefits:
        data.usage?.benefits?.map((b) => {
          return PriceBenefitsInputModel.deserializeAPIModel(b);
        }) || [],
      programAndLevels:
        data.programAndLevels?.map((p) => {
          return PriceProgramAndLevelsMappingModel.deserializeAPIModel(p);
        }) || [],
    };

    return new ServiceAndMembershipOptionsPageModel(mappedData);
  }
}
